import { graphql } from 'react-relay';
export const SpaceOperationsQuery = graphql`
	query SpaceOperationsQuery($spaceKey: String!) {
		space(key: $spaceKey) {
			id
			operations {
				operation
				targetType
			}
		}
	}
`;
